const RANKING_ITEMS = [
  { rank: 1, title: '我独自升级', type: '完结', heat: '热度 9.9', change: 'up' },
  { rank: 2, title: '全知读者视角', type: '连载', heat: '热度 9.8', change: 'up' },
  { rank: 3, title: '神之塔', type: '连载', heat: '热度 9.6', change: 'same' },
  { rank: 4, title: '甜蜜家园', type: '完结', heat: '热度 9.5', change: 'down' },
  { rank: 5, title: '女神降临', type: '完结', heat: '热度 9.3', change: 'up' },
  { rank: 6, title: '梨泰院Class', type: '完结', heat: '热度 9.2', change: 'same' },
  { rank: 7, title: '金秘书为何那样', type: '完结', heat: '热度 9.0', change: 'up' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          人气排行
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          基于全网韩国漫画网站数据综合计算的热度榜单
        </p>
        <div className="bg-background-50 rounded-2xl overflow-hidden">
          {RANKING_ITEMS.map((item, i) => (
            <div
              key={item.title}
              className={`flex items-center gap-4 p-4 md:p-5 ${
                i < RANKING_ITEMS.length - 1 ? 'border-b border-background-200/70' : ''
              } hover:bg-background-100/50 transition-colors cursor-pointer`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded bg-background-200 text-foreground-500 text-xs whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
                <i className={`text-sm ${
                  item.change === 'up' ? 'ri-arrow-up-line text-primary-600' :
                  item.change === 'down' ? 'ri-arrow-down-line text-accent-600' :
                  'ri-subtract-line text-foreground-400'
                }`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}